module.exports = __webpack_public_path__ + "img/green_use_of_land.419f0d5b.svg";